import React from 'react'
import { useSelector } from 'react-redux'

import { getChannel } from 'data/channels/selectors'
import { getChannelLabel } from 'data/channels/helpers'
import ChannelsShowLayout from './Layout'

type ChannelsShowContainerProps = {
  channelId: string
}

export default function ChannelsShowContainer({
  channelId,
}: ChannelsShowContainerProps) {
  const channelTitle = useSelector(state =>
    getChannelLabel(getChannel(state, channelId))
  )

  return (
    <ChannelsShowLayout channelId={channelId} channelTitle={channelTitle} />
  )
}
